import { Injectable } from '@angular/core'
import { add, format, getYear, lastDayOfYear, sub } from 'date-fns'
import { AppConstants } from '../../../constants/app-constants'

@Injectable({
    providedIn: 'root'
})
export class PaymentsPayoutDateService {

    private outgoingPayoutDates: any[] = null
    private incomingPayoutDates: any[] = null

    getOutgoingPayoutDates(): any[] {
        return this.outgoingPayoutDates
    }

    getIncomingPayoutDates(): any[] {
        return this.incomingPayoutDates
    }

    isNullOutgoingPayoutDates(): boolean {
        return this.outgoingPayoutDates === null
    }

    isNullIncomingPayoutDates(): boolean {
        return this.incomingPayoutDates === null
    }

    resetDates(): void {
        this.outgoingPayoutDates = null
        this.incomingPayoutDates = null
    }

    setOutgoingPayoutDates(dates): void {
        this.outgoingPayoutDates = dates
    }

    setIncomingPayoutDates(dates): void {
        this.incomingPayoutDates = dates
    }

    getValidPayoutDateFrom(year, payoutDateInNext30Days, payoutDateExpired): string {
        let fromDate = null
        if (!year) {
            year = payoutDateExpired ? 1970 : getYear(new Date())
        }
        if (payoutDateInNext30Days) {
            fromDate = new Date()
        }
        if (payoutDateExpired) {
            fromDate = new Date(year, 0, 1)
        }
        if (fromDate === null) {
            return null
        }
        return format(fromDate, 'yyyy-MM-dd')
    }

    getValidPayoutDateTo(year, payoutDateInNext30Days, payoutDateExpired): string {
        let toDate = null
        if (!year) {
            year = getYear(new Date())
        }
        if (payoutDateExpired) {
            if (getYear(new Date()) > year) {
                toDate = lastDayOfYear(new Date(year, 0, 1))
            } else {
                toDate = sub(new Date(), { days: 1 })
            }
        }
        if (payoutDateInNext30Days) {
            const today = new Date()
            toDate = add(today, { days: AppConstants.ONCOMING_UNPAID_PAYMENTS_DAYS_LIMIT })

            if (getYear(toDate) > getYear(today)) {
                //December = 11
                toDate = new Date(today.getFullYear(), 11, 31)
            }
        }
        if (toDate === null) {
            return null
        }
        return format(toDate, 'yyyy-MM-dd')
    }
}
